import type { TypedDocumentNode } from '@apollo/client';

import { gql } from '@apollo/client';

import type {
  DocumentUpdatedSubscription,
  DocumentUpdatedSubscriptionVariables,
} from '#graphql/generated';

export const DOCUMENT_UPDATED: TypedDocumentNode<
  DocumentUpdatedSubscription,
  DocumentUpdatedSubscriptionVariables
> = gql`
  subscription DocumentUpdated($path: String!) {
    documentUpdated(path: $path) {
      documentId
      path
      ownerUserId
      updatedAt
      editTimestamp
    }
  }
`;
